// src/hooks/useCatalogueProcessus.ts
//
// Liste des processus que l'organisation peut démarrer — la SOURCE UNIQUE du
// menu latéral et du catalogue des processus (décision EEC, 17/09/2026).
// Chargée une fois puis servie depuis le cache de demandesClientService.
import { useEffect, useState } from 'react';
import { demandesClientService, DemandeClientItem } from '../services/demandes-client.service';

export function useCatalogueProcessus(): { processus: DemandeClientItem[]; loading: boolean } {
  const [processus, setProcessus] = useState<DemandeClientItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let annule = false;
    demandesClientService.catalogueEnCache()
      .then(liste => { if (!annule) setProcessus(liste); })
      .catch(() => { if (!annule) setProcessus([]); })
      .finally(() => { if (!annule) setLoading(false); });
    return () => { annule = true; };
  }, []);

  return { processus, loading };
}
